export function showStartupError({ title, retryLabel }, doc = document, retry = () => window.location.reload()) {
  const loading = doc.getElementById('loading-bg');
  if (!loading || loading.style.display === 'none') return;

  const panel = doc.createElement('div');
  panel.className = 'startup-error';
  panel.setAttribute('role', 'alert');
  const message = doc.createElement('p');
  message.textContent = title;
  const button = doc.createElement('button');
  button.type = 'button';
  button.textContent = retryLabel;
  button.addEventListener('click', retry);
  panel.append(message, button);
  loading.replaceChildren(panel);
}
